import { Box, FormHelperText, Grid, Stack } from "@mui/material";
import CustomTextField from "../../../components/Form/CustomTextField";
import CustomSelect from "../../../components/Form/CustomSelect";
import React from "react";
import CustomButton from "../../../components/Form/CustomButton";
import { Icon } from "@iconify/react/dist/iconify.js";
import CheckBox from "../../../components/Form/CheckBox";
import CustomSelectMultiple from "../../../components/Form/CustomSelectMultiple";
import CustomIconButton from "../../../components/Form/CustomIconButton";

export default function AccessoryInfo({ formObj, handleFormChange, error, brandList, categoryList, subCategoryList, makeList, modelList }) {
    const [addNewModel, setAddNewModel] = React.useState(false);
    const [newModel, setNewModel] = React.useState({ make: '', model: '' });
    const [editRow, setEditRow] = React.useState();

    const compatibleList = [
        { label: 'Fits all motocycles', value: 'fit_all' },
        { label: 'By make / model', value: 'by_make_model' },
    ]

    const handleSaveNewModel = () => {
        handleFormChange('make_model', [...formObj?.make_model || [], { ...newModel, id: (formObj?.make_model?.length || 0) + 1 }]);
        setAddNewModel(false);
        setNewModel({ make: '', model: '' })
    }

    const handleSaveEditModel = () => {
        let tempArr = formObj?.make_model || [];
        const index = tempArr.findIndex(item => item.id === editRow.id);
        if (index !== -1) {
            tempArr[index] = editRow;
        }
        handleFormChange('make_model', tempArr);
        setEditRow(null);
    }

    const handleDeleteModel = (index) => {
        let tempArr = formObj?.make_model || [];
        tempArr.splice(index, 1);
        handleFormChange('make_model', tempArr);
    }

    return (
        <React.Fragment>
            <Box mt={2}>
                <div className="text-semibold">About</div>
                <Grid container spacing={1}>
                    <Grid item sm={12} xs={12}>
                        <CustomSelect
                            title={'Brand'}
                            placeholder={'Brand'}
                            values={formObj?.brand_id || '-1'}
                            data={brandList || []}
                            onChange={(e) => handleFormChange('brand_id', e)}
                            labelName={'name'}
                            valueName={'id'}
                            error={error?.brand_id}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <CustomTextField
                            title={'Accessory name'}
                            placeholder={'Accessory name'}
                            values={formObj?.name || ''}
                            onChange={(e) => handleFormChange('name', e)}
                            error={error?.name}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <CustomSelect
                            title={'Category'}
                            placeholder={'Category'}
                            values={formObj?.category_id || '-1'}
                            data={categoryList || []}
                            onChange={(e) => handleFormChange('category_id', e)}
                            labelName={'name'}
                            valueName={'id'}
                            error={error?.category_id}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <CustomSelect
                            title={'Sub-Category'}
                            placeholder={'Sub-Category'}
                            values={formObj?.sub_category_id || '-1'}
                            data={formObj?.category_id ? categoryList?.find((item) => item.id === formObj?.category_id)?.sub_categories || [] : []}
                            onChange={(e) => handleFormChange('sub_category_id', e)}
                            labelName={'name'}
                            valueName={'id'}
                            error={error?.sub_category_id}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box mt={4}>
                <div className="text-semibold">Compatible Models</div>
                <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                    {compatibleList.map((item, index) => (
                        <div className={formObj?.compatible === item.value ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleFormChange('compatible', item.value)}>
                            {item.label}
                        </div>
                    ))}
                </Stack>
            </Box>
            {
                formObj?.compatible === 'by_make_model' &&
                <Box mt={4}>
                    <Grid container spacing={2}>
                        <Grid item sm={6} xs={12} className="d-flex align-items-center">
                            <div className="text-semibold">Select by Make / model</div>
                        </Grid>
                        <Grid item sm={6} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end', sm: 'end', xs: 'start' } }}>
                            <CustomButton
                                title={'Add make / model'}
                                press={() => setAddNewModel(true)}
                            />
                        </Grid>
                        {error?.compatibilities && formObj?.compatible === "by_make_model" && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.compatibilities && formObj?.compatible === "by_make_model" ? "Please select compatible models" : ""}</FormHelperText>}

                        {
                            addNewModel &&
                            <Grid item sm={12}>
                                <div className="dashboard-card">
                                    <div className="text-semibold">Make</div>
                                    <CustomSelect
                                        title={'Make'}
                                        placeholder={'Make'}
                                        values={newModel?.make || ''}
                                        data={makeList || []}
                                        labelName={'name'}
                                        valueName={'id'}
                                        onChange={(e) => setNewModel({ ...newModel, make: e, model: '' })}
                                    />
                                    {
                                        !newModel?.is_apply_all &&
                                        <>
                                            <div className="text-semibold mt-2">Model</div>
                                            <CustomSelectMultiple
                                                title={"Model"}
                                                placeholder={'Model'}
                                                values={newModel?.model || []}
                                                onChange={(e) => {
                                                    const allModels = newModel?.make ? makeList?.find(item => item.id === newModel?.make)?.models?.map(model => model.id) || [] : modelList?.map(model => model.id) || [];
                                                    const selectedModels = e;
                                                    const isApplyAll = allModels.length > 0 && allModels.every(model => selectedModels.includes(model));

                                                    setNewModel({ ...newModel, model: selectedModels, is_apply_all: isApplyAll });
                                                }} data={newModel?.make ? makeList?.find(item => item.id === newModel?.make)?.models || [] : modelList || []}
                                                labelName={'name'}
                                                valueName={'id'}
                                            />
                                        </>
                                    }
                                    <div className="mt-2">
                                        <CheckBox
                                            label={'Applies to all models under selected make'}
                                            values={newModel?.is_apply_all}
                                            onChange={(e) => setNewModel({ ...newModel, is_apply_all: e.target.checked, model: e.target.checked ? makeList?.find(item => item.id === newModel?.make)?.models?.map(model => model.id) || [] : [] })}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <CustomButton
                                            title={'Cancel'}
                                            press={() => { setAddNewModel(false); setNewModel({ make: '', model: '' }) }}
                                            backgroundColor={'#F9F9F9'}
                                            textColor={'#808588'}
                                            borderStyle={'1px solid #F9F9F9'}
                                            width={'50%'}
                                            padding={20}
                                        />
                                        <CustomButton
                                            title={'Save'}
                                            press={() => { handleSaveNewModel(); }}
                                            width={'50%'}
                                            padding={20}
                                            marginLeft={10}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        }
                        {
                            editRow &&
                            <Grid item sm={12}>
                                <div className="dashboard-card">
                                    <div className="text-semibold">Make</div>
                                    <CustomSelect
                                        title={'Make'}
                                        placeholder={'Make'}
                                        values={editRow?.make || '-1'}
                                        data={makeList || []}
                                        labelName={'name'}
                                        valueName={'id'}
                                        onChange={(e) => setEditRow({ ...editRow, make: e, model: '' })}
                                    />
                                    {
                                        !editRow?.is_apply_all &&
                                        <>
                                            <div className="text-semibold mt-2">Model</div>
                                            <CustomSelectMultiple
                                                title="Model"
                                                placeholder={'Model'}
                                                values={editRow?.model || []}
                                                onChange={(e) => {
                                                    const allModels = editRow?.make
                                                        ? makeList?.find(item => item.id === editRow?.make)?.models?.map(model => model.id) || []
                                                        : modelList?.map(model => model.id) || [];
                                                    const selectedModels = e;
                                                    const isApplyAll = allModels.length > 0 && allModels.every(model => selectedModels.includes(model));

                                                    setEditRow({ ...editRow, model: selectedModels, is_apply_all: isApplyAll });
                                                }}
                                                data={editRow?.make ? makeList?.find(item => item.id === editRow?.make)?.models || [] : modelList || []}
                                                labelName={'name'}
                                                valueName={'id'}
                                            />
                                        </>
                                    }
                                    <div className="mt-2">
                                        <CheckBox
                                            label={'Applies to all models under selected make'}
                                            values={editRow?.is_apply_all}
                                            onChange={(e) => setEditRow({ ...editRow, is_apply_all: e.target.checked, model: e.target.checked ? makeList?.find(item => item.id === editRow?.make)?.models?.map(model => model.id) || [] : [] })}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <CustomButton
                                            title={'Cancel'}
                                            press={() => { setEditRow(null) }}
                                            backgroundColor={'#F9F9F9'}
                                            textColor={'#808588'}
                                            borderStyle={'1px solid #F9F9F9'}
                                            width={'50%'}
                                            padding={20}
                                        />
                                        <CustomButton
                                            title={'Save'}
                                            press={() => { handleSaveEditModel(); }}
                                            width={'50%'}
                                            padding={20}
                                            marginLeft={10}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        }
                        <Grid item sm={12} xs={12}>
                            {
                                formObj?.make_model?.length > 0 ? formObj?.make_model.map((item, index) => {
                                    const makeName = makeList.find(m => m.id === item.make)?.name || '-';
                                    const modelName = item?.model ? item?.model?.map((x) => {
                                        const modelObj = modelList.find(m => m.id === x);
                                        return modelObj ? modelObj.name : '';
                                    }).join(", ") : '-';
                                    return (
                                        <>
                                            <div key={index} className="dashboard-card" style={{ marginBottom: index === formObj?.make_model?.length - 1 ? 0 : 15 }}>
                                                <Grid container spacing={2}>
                                                    <Grid item lg={9} md={9} sm={9} xs={9}>
                                                        <div style={{ fontWeight: 700 }}>{makeName || '-'}</div>
                                                        <div className="d-flex align-items-center">
                                                            <div className="subheader-2">Selected Models: </div>
                                                            <div className="text-semibold mx-2">{item?.is_apply_all ? 'All' : modelName}</div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item lg={3} md={3} sm={3} xs={3} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end', sm: 'end', xs: 'start' } }}>
                                                        <CustomIconButton
                                                            iconName={'ri:pencil-line'}
                                                            onClick={() => setEditRow(item)}
                                                        />
                                                        <CustomIconButton
                                                            iconName={'ri:delete-bin-line'}
                                                            color={'#D13536'}
                                                            onClick={() => handleDeleteModel(index)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </div>
                                            {error?.[`compatibilities.${index}.bike_make_id`] && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.[`compatibilities.${index}.bike_make_id`] || ""}</FormHelperText>}
                                            {error?.[`compatibilities.${index}.bike_model_ids`] && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.[`compatibilities.${index}.bike_model_ids`]?.[0] || ""}</FormHelperText>}
                                        </>
                                    )
                                }) :
                                    <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: '#F9F9F9', color: '#BDBDBD', border: '1px dashed #D9D9D9', height: 151, width: '100%', borderRadius: 8 }}>
                                        <div className="text-center">
                                            <Icon icon={'ri:file-paper-line'} style={{ fontSize: 24 }} />
                                            <div>No added make or model yet. </div>
                                        </div>

                                    </div>
                            }
                        </Grid>
                    </Grid>
                </Box>
            }
            <Box mt={4}>
                <div className="text-semibold">Pricing</div>
                <Grid container spacing={2}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                            title={'Selling price'}
                            placeholder={'Selling price'}
                            values={formObj?.selling_price || ''}
                            onChange={(e) => handleFormChange('selling_price', e)}
                            type={'number'}
                            InputProps={{ startAdornment: '$' }}
                            error={error?.selling_price}
                        />
                    </Grid>
                    {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                            title={'Promotion price (if any)'}
                            placeholder={'Promotion price (if any)'}
                            values={formObj?.promotion_price || ''}
                            onChange={(e) => handleFormChange('promotion_price', e)}
                            type={'number'}
                            InputProps={{ startAdornment: '$' }}
                        />
                    </Grid> */}
                </Grid>
            </Box>
        </React.Fragment>

    )
}